module.exports = __webpack_public_path__ + "img/第1章_3-1_彰化車站.jpg";